import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getErrorReport = (params) => httpClient.get(`${ENDPOINT_API.ERRORS}`, { params });
const postErrorResolve = (id, params) => httpClient.put(`${ENDPOINT_API.ERRORS}/${id}`, params);

export {
	getErrorReport,
	postErrorResolve,
};
